import { createSlice } from "@reduxjs/toolkit";
import { cleanUpTableauViz } from "../../modules/Dashboard/TableauPortal";

type InitialState = {
  isAuthenticated: boolean;
  resourceName: string;
  tableauTab: string;
};

const initialState: InitialState = {
  isAuthenticated: !!localStorage.getItem("isLoggedIn"),
  resourceName: localStorage.getItem("resourceName") || "cimpar",
  tableauTab: "",
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthenticated: (state) => {
      state.isAuthenticated = true;
    },
    logOut: (state) => {
      state.isAuthenticated = false;
      localStorage.removeItem("isLoggedIn");
      cleanUpTableauViz();
    },
    setResourceName: (state, action) => {
      state.resourceName = action.payload;
    },
    setTableauTab: (state, action) => {
      state.tableauTab = action.payload;
    },
  },
});

export const authActions = authSlice.actions;
export default authSlice.reducer;
